import { ColourTags } from '@/utilities/paperwork/enums/ColourTags'
import { MapTypeEnum } from '@/utilities/map/enums/MapTypeEnum'

export default {
  install(Vue: any, options: any) {
    Vue.$googleImages = Vue.prototype.$googleImages = {
      googleApiKey: options.googleMapsApiKey,
      streetViewUrl: 'https://maps.googleapis.com/maps/api/streetview',
      staticMapUrl: 'https://maps.googleapis.com/maps/api/staticmap',

      /**
       * 'https://maps.googleapis.com/maps/api/staticmap?key={key}&size={size}&maptype=roadmap&center={coordinates}&zoom=15',
       */
      getMapImage(data: { coordinates: string; location: string; maptype: string; zoom: number; colour: string }): string {
        let url = this.staticMapUrl
        url += '?key=' + encodeURIComponent(this.googleApiKey)
        url += '&size=550x400'
        url += `&maptype=${data.maptype ?? MapTypeEnum.ROADMAP}`
        url += `&center=${data.coordinates}`
        url += `&zoom=${data.zoom ?? 14}`
        // if map has marker
        url += data.location ? `&markers=color:${data.colour ?? ColourTags.RED}|${data.location}` : ''
        return url
      },

      /**
       * 'https://maps.googleapis.com/maps/api/streetview?key={key}&size={size}&location={coordinates}&heading=0&pitch=0',
       * @param data
       */
      getStreetViewImage(data: { coordinates: string; heading: number; pitch: number }): string {
        let url = this.streetViewUrl
        url += '?key=' + encodeURIComponent(this.googleApiKey)
        /* Add query parameters */
        url += '&size=550x400'
        url += data.coordinates ? `&location=${data.coordinates}` : ''
        url += `&heading=${data.heading ?? 0}`
        url += `&pitch=${data.pitch ?? 0}`
        return url
      },
    }
  },
}
